module.exports = __webpack_public_path__ + "static/welcome-e4bf115853c23a4768849825acb0022c.jpg";